
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2015-05-10-discover-the-railyard",
      function () {
        return require("private-next-pages/posts/2015-05-10-discover-the-railyard.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2015-05-10-discover-the-railyard"])
      });
    }
  